// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TabsOne {
  background-color: rgb(228, 220, 206);
  /* border: 2px solid #000; */
}
.TabsOne:hover {
  background-color: #c1c1c1;
}
`, "",{"version":3,"sources":["webpack://./src/Sidebar/EmployeesProfile.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,4BAA4B;AAC9B;AACA;EACE,yBAAyB;AAC3B","sourcesContent":[".TabsOne {\r\n  background-color: rgb(228, 220, 206);\r\n  /* border: 2px solid #000; */\r\n}\r\n.TabsOne:hover {\r\n  background-color: #c1c1c1;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
